import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
  data: [],
  isImporting: false,
  status: null,
};

const token = userObj?.token;

export const importShipments = createAsyncThunk(
  "pickups/importShipment",
  async ({id, data}, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/Order/ImportShipment?Id=${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (err) {
      console.log(err.response);
      return rejectWithValue(err.response.data[0]);
    }
  }
);

const importShipmentSlice = createSlice({
  name: "importShipment",
  initialState,
  reducers: {},
  extraReducers: {
    [importShipments.pending]: (state, action) => {
      state.status = "pending";
      state.isImporting = true;
    },
    [importShipments.fulfilled]: (state, action) => {
      state.status = "success";
      state.isImporting = false;
      state.data = action.payload;
      // localStorage.setItem('user', JSON.stringify(action.payload))
    },

    [importShipments.rejected]: (state, action) => {
      state.status = "failed";
      state.isImporting = false;
    },
  },
});

export default importShipmentSlice.reducer;
